import { Skeleton } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import React from "react";

const ITEM_HEIGHT = 36;

const NavItemSkeleton = ({ open }) => (
  <ListItem sx={{ px: 1.5, py: 0.5 }}>
    <Skeleton
      variant="rounded"
      height={ITEM_HEIGHT}
      width={open ? "100%" : ITEM_HEIGHT}
      data-testid="navigation-item-skeleton"
    />
  </ListItem>
);

export default NavItemSkeleton;
